exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[type=email][data-v-ab7a6b1a],.form-control[type=number][data-v-ab7a6b1a],.form-control[type=search][data-v-ab7a6b1a],.form-control[type=tel][data-v-ab7a6b1a],.form-control[type=text][data-v-ab7a6b1a],textarea.form-control[data-v-ab7a6b1a]{border-radius:5px;font-size:14px}.dropdown[data-v-ab7a6b1a]{display:inline-block}.form-control-label[data-v-ab7a6b1a]{margin-bottom:.5rem;padding:0}.header[data-v-ab7a6b1a],.set-buttons[data-v-ab7a6b1a]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}label[data-v-ab7a6b1a]{font-weight:500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab7a6b1a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/order-layout/action/action-groups.vue
// module id = 7Hdc
// module chunks = 50